/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { aiAnalysisRunImages } from './ai_analysis_run_images.js';
import { aiAnalysisRuns } from './ai_analysis_runs.js';
import { appConfig } from './app_config.js';
import { appointmentAvailabilityRules } from './appointment_availability_rules.js';
import { appointmentCalendarSettings } from './appointment_calendar_settings.js';
import { appointmentCategories } from './appointment_categories.js';
import { appointmentProviderTypes } from './appointment_provider_types.js';
import { appointmentProviders } from './appointment_providers.js';
import { appointmentServices } from './appointment_services.js';
import { appointmentSlots } from './appointment_slots.js';
import { appointmentStatuses } from './appointment_statuses.js';
import { appointmentWhatsappResponses } from './appointment_whatsapp_responses.js';
import { appointments } from './appointments.js';
import { billingAdjustments } from './billing_adjustments.js';
import { bookingFrontdeskPatientFieldSettings } from './booking_frontdesk_patient_field_settings.js';
import { bookingFrontdeskProviderSettings } from './booking_frontdesk_provider_settings.js';
import { bookingFrontdeskServiceSettings } from './booking_frontdesk_service_settings.js';
import { bookingFrontdeskSettings } from './booking_frontdesk_settings.js';
import { bookingOnlinePatientFieldSettings } from './booking_online_patient_field_settings.js';
import { bookingOnlineProviderSettings } from './booking_online_provider_settings.js';
import { bookingOnlineServiceSettings } from './booking_online_service_settings.js';
import { bookingOnlineSettings } from './booking_online_settings.js';
import { chartingTemplates } from './charting_templates.js';
import { deliveryOrderLines } from './delivery_order_lines.js';
import { deliveryOrders } from './delivery_orders.js';
import { encounterTabSettings } from './encounter_tab_settings.js';
import { encounterVisualCharts } from './encounter_visual_charts.js';
import { formDefinitions } from './form_definitions.js';
import { formInstanceSignatures } from './form_instance_signatures.js';
import { formInstanceValues } from './form_instance_values.js';
import { formInstances } from './form_instances.js';
import { formTemplateMappings } from './form_template_mappings.js';
import { formTemplatePages } from './form_template_pages.js';
import { intakeFormDefinitions } from './intake_form_definitions.js';
import { intakeFormResponses } from './intake_form_responses.js';
import { inventoryAdjustmentLines } from './inventory_adjustment_lines.js';
import { inventoryAdjustments } from './inventory_adjustments.js';
import { inventoryBatches } from './inventory_batches.js';
import { inventoryItems } from './inventory_items.js';
import { inventoryMedicineDetails } from './inventory_medicine_details.js';
import { inventoryPackageItems } from './inventory_package_items.js';
import { inventorySuppliers } from './inventory_suppliers.js';
import { invoiceItems } from './invoice_items.js';
import { invoicePayments } from './invoice_payments.js';
import { invoicePrintSettings } from './invoice_print_settings.js';
import { invoices } from './invoices.js';
import { notificationDeliveries } from './notification_deliveries.js';
import { notificationJobs } from './notification_jobs.js';
import { notificationTemplates } from './notification_templates.js';
import { odontogramCharts } from './odontogram_charts.js';
import { patientAllergies } from './patient_allergies.js';
import { patientCommunicationPreferences } from './patient_communication_preferences.js';
import { patientContacts } from './patient_contacts.js';
import { patientDiagnosisEntries } from './patient_diagnosis_entries.js';
import { patientDiagnosisSuggestions } from './patient_diagnosis_suggestions.js';
import { patientEmergencyContacts } from './patient_emergency_contacts.js';
import { patientEncounters } from './patient_encounters.js';
import { patientFieldDefinitions } from './patient_field_definitions.js';
import { patientFiles } from './patient_files.js';
import { patientForms } from './patient_forms.js';
import { patientIdentifiers } from './patient_identifiers.js';
import { patientIntakeForms } from './patient_intake_forms.js';
import { patientNotes } from './patient_notes.js';
import { patientPackageItems } from './patient_package_items.js';
import { patientPackageRedemptions } from './patient_package_redemptions.js';
import { patientPackages } from './patient_packages.js';
import { patientPrescriptions } from './patient_prescriptions.js';
import { patientSymptomEntries } from './patient_symptom_entries.js';
import { patientTreatmentEntries } from './patient_treatment_entries.js';
import { patientTreatmentRecords } from './patient_treatment_records.js';
import { patientVisits } from './patient_visits.js';
import { patientVitalEntries } from './patient_vital_entries.js';
import { patientWorkspaceSettings } from './patient_workspace_settings.js';
import { patients } from './patients.js';
import { pharmacyDispenseLines } from './pharmacy_dispense_lines.js';
import { pharmacyDispenses } from './pharmacy_dispenses.js';
import { prescriptionPrintSettings } from './prescription_print_settings.js';
import { prescriptionTemplateItems } from './prescription_template_items.js';
import { prescriptionTemplates } from './prescription_templates.js';
import { productReleaseLines } from './product_release_lines.js';
import { productReleases } from './product_releases.js';
import { purchaseOrderLines } from './purchase_order_lines.js';
import { purchaseOrderPrintSettings } from './purchase_order_print_settings.js';
import { purchaseOrders } from './purchase_orders.js';
import { queueEntries } from './queue_entries.js';
import { stockMovements } from './stock_movements.js';
import { usedSupplies } from './used_supplies.js';
import { userPatientFavorites } from './user_patient_favorites.js';
import { userProviderLinks } from './user_provider_links.js';
import { users } from './users.js';
import { vitalDefinitions } from './vital_definitions.js';

// Re-export individual table definitions
export { aiAnalysisRunImages } from './ai_analysis_run_images.js';
export { aiAnalysisRuns } from './ai_analysis_runs.js';
export { appConfig } from './app_config.js';
export { appointmentAvailabilityRules } from './appointment_availability_rules.js';
export { appointmentCalendarSettings } from './appointment_calendar_settings.js';
export { appointmentCategories } from './appointment_categories.js';
export { appointmentProviderTypes } from './appointment_provider_types.js';
export { appointmentProviders } from './appointment_providers.js';
export { appointmentServices } from './appointment_services.js';
export { appointmentSlots } from './appointment_slots.js';
export { appointmentStatuses } from './appointment_statuses.js';
export { appointmentWhatsappResponses } from './appointment_whatsapp_responses.js';
export { appointments } from './appointments.js';
export { billingAdjustments } from './billing_adjustments.js';
export { bookingFrontdeskPatientFieldSettings } from './booking_frontdesk_patient_field_settings.js';
export { bookingFrontdeskProviderSettings } from './booking_frontdesk_provider_settings.js';
export { bookingFrontdeskServiceSettings } from './booking_frontdesk_service_settings.js';
export { bookingFrontdeskSettings } from './booking_frontdesk_settings.js';
export { bookingOnlinePatientFieldSettings } from './booking_online_patient_field_settings.js';
export { bookingOnlineProviderSettings } from './booking_online_provider_settings.js';
export { bookingOnlineServiceSettings } from './booking_online_service_settings.js';
export { bookingOnlineSettings } from './booking_online_settings.js';
export { chartingTemplates } from './charting_templates.js';
export { deliveryOrderLines } from './delivery_order_lines.js';
export { deliveryOrders } from './delivery_orders.js';
export { encounterTabSettings } from './encounter_tab_settings.js';
export { encounterVisualCharts } from './encounter_visual_charts.js';
export { formDefinitions } from './form_definitions.js';
export { formInstanceSignatures } from './form_instance_signatures.js';
export { formInstanceValues } from './form_instance_values.js';
export { formInstances } from './form_instances.js';
export { formTemplateMappings } from './form_template_mappings.js';
export { formTemplatePages } from './form_template_pages.js';
export { intakeFormDefinitions } from './intake_form_definitions.js';
export { intakeFormResponses } from './intake_form_responses.js';
export { inventoryAdjustmentLines } from './inventory_adjustment_lines.js';
export { inventoryAdjustments } from './inventory_adjustments.js';
export { inventoryBatches } from './inventory_batches.js';
export { inventoryItems } from './inventory_items.js';
export { inventoryMedicineDetails } from './inventory_medicine_details.js';
export { inventoryPackageItems } from './inventory_package_items.js';
export { inventorySuppliers } from './inventory_suppliers.js';
export { invoiceItems } from './invoice_items.js';
export { invoicePayments } from './invoice_payments.js';
export { invoicePrintSettings } from './invoice_print_settings.js';
export { invoices } from './invoices.js';
export { notificationDeliveries } from './notification_deliveries.js';
export { notificationJobs } from './notification_jobs.js';
export { notificationTemplates } from './notification_templates.js';
export { odontogramCharts } from './odontogram_charts.js';
export { patientAllergies } from './patient_allergies.js';
export { patientCommunicationPreferences } from './patient_communication_preferences.js';
export { patientContacts } from './patient_contacts.js';
export { patientDiagnosisEntries } from './patient_diagnosis_entries.js';
export { patientDiagnosisSuggestions } from './patient_diagnosis_suggestions.js';
export { patientEmergencyContacts } from './patient_emergency_contacts.js';
export { patientEncounters } from './patient_encounters.js';
export { patientFieldDefinitions } from './patient_field_definitions.js';
export { patientFiles } from './patient_files.js';
export { patientForms } from './patient_forms.js';
export { patientIdentifiers } from './patient_identifiers.js';
export { patientIntakeForms } from './patient_intake_forms.js';
export { patientNotes } from './patient_notes.js';
export { patientPackageItems } from './patient_package_items.js';
export { patientPackageRedemptions } from './patient_package_redemptions.js';
export { patientPackages } from './patient_packages.js';
export { patientPrescriptions } from './patient_prescriptions.js';
export { patientSymptomEntries } from './patient_symptom_entries.js';
export { patientTreatmentEntries } from './patient_treatment_entries.js';
export { patientTreatmentRecords } from './patient_treatment_records.js';
export { patientVisits } from './patient_visits.js';
export { patientVitalEntries } from './patient_vital_entries.js';
export { patientWorkspaceSettings } from './patient_workspace_settings.js';
export { patients } from './patients.js';
export { pharmacyDispenseLines } from './pharmacy_dispense_lines.js';
export { pharmacyDispenses } from './pharmacy_dispenses.js';
export { prescriptionPrintSettings } from './prescription_print_settings.js';
export { prescriptionTemplateItems } from './prescription_template_items.js';
export { prescriptionTemplates } from './prescription_templates.js';
export { productReleaseLines } from './product_release_lines.js';
export { productReleases } from './product_releases.js';
export { purchaseOrderLines } from './purchase_order_lines.js';
export { purchaseOrderPrintSettings } from './purchase_order_print_settings.js';
export { purchaseOrders } from './purchase_orders.js';
export { queueEntries } from './queue_entries.js';
export { stockMovements } from './stock_movements.js';
export { usedSupplies } from './used_supplies.js';
export { userPatientFavorites } from './user_patient_favorites.js';
export { userProviderLinks } from './user_provider_links.js';
export { users } from './users.js';
export { vitalDefinitions } from './vital_definitions.js';

/**
 * Combined Drizzle schema object.
 * Keys MUST match the PowerSync table names used in sync rules.
 */
export const drizzleSchema = {
  ai_analysis_run_images: aiAnalysisRunImages,
  ai_analysis_runs: aiAnalysisRuns,
  app_config: appConfig,
  appointment_availability_rules: appointmentAvailabilityRules,
  appointment_calendar_settings: appointmentCalendarSettings,
  appointment_categories: appointmentCategories,
  appointment_provider_types: appointmentProviderTypes,
  appointment_providers: appointmentProviders,
  appointment_services: appointmentServices,
  appointment_slots: appointmentSlots,
  appointment_statuses: appointmentStatuses,
  appointment_whatsapp_responses: appointmentWhatsappResponses,
  appointments: appointments,
  billing_adjustments: billingAdjustments,
  booking_frontdesk_patient_field_settings: bookingFrontdeskPatientFieldSettings,
  booking_frontdesk_provider_settings: bookingFrontdeskProviderSettings,
  booking_frontdesk_service_settings: bookingFrontdeskServiceSettings,
  booking_frontdesk_settings: bookingFrontdeskSettings,
  booking_online_patient_field_settings: bookingOnlinePatientFieldSettings,
  booking_online_provider_settings: bookingOnlineProviderSettings,
  booking_online_service_settings: bookingOnlineServiceSettings,
  booking_online_settings: bookingOnlineSettings,
  charting_templates: chartingTemplates,
  delivery_order_lines: deliveryOrderLines,
  delivery_orders: deliveryOrders,
  encounter_tab_settings: encounterTabSettings,
  encounter_visual_charts: encounterVisualCharts,
  form_definitions: formDefinitions,
  form_instance_signatures: formInstanceSignatures,
  form_instance_values: formInstanceValues,
  form_instances: formInstances,
  form_template_mappings: formTemplateMappings,
  form_template_pages: formTemplatePages,
  intake_form_definitions: intakeFormDefinitions,
  intake_form_responses: intakeFormResponses,
  inventory_adjustment_lines: inventoryAdjustmentLines,
  inventory_adjustments: inventoryAdjustments,
  inventory_batches: inventoryBatches,
  inventory_items: inventoryItems,
  inventory_medicine_details: inventoryMedicineDetails,
  inventory_package_items: inventoryPackageItems,
  inventory_suppliers: inventorySuppliers,
  invoice_items: invoiceItems,
  invoice_payments: invoicePayments,
  invoice_print_settings: invoicePrintSettings,
  invoices: invoices,
  notification_deliveries: notificationDeliveries,
  notification_jobs: notificationJobs,
  notification_templates: notificationTemplates,
  odontogram_charts: odontogramCharts,
  patient_allergies: patientAllergies,
  patient_communication_preferences: patientCommunicationPreferences,
  patient_contacts: patientContacts,
  patient_diagnosis_entries: patientDiagnosisEntries,
  patient_diagnosis_suggestions: patientDiagnosisSuggestions,
  patient_emergency_contacts: patientEmergencyContacts,
  patient_encounters: patientEncounters,
  patient_field_definitions: patientFieldDefinitions,
  patient_files: patientFiles,
  patient_forms: patientForms,
  patient_identifiers: patientIdentifiers,
  patient_intake_forms: patientIntakeForms,
  patient_notes: patientNotes,
  patient_package_items: patientPackageItems,
  patient_package_redemptions: patientPackageRedemptions,
  patient_packages: patientPackages,
  patient_prescriptions: patientPrescriptions,
  patient_symptom_entries: patientSymptomEntries,
  patient_treatment_entries: patientTreatmentEntries,
  patient_treatment_records: patientTreatmentRecords,
  patient_visits: patientVisits,
  patient_vital_entries: patientVitalEntries,
  patient_workspace_settings: patientWorkspaceSettings,
  patients: patients,
  pharmacy_dispense_lines: pharmacyDispenseLines,
  pharmacy_dispenses: pharmacyDispenses,
  prescription_print_settings: prescriptionPrintSettings,
  prescription_template_items: prescriptionTemplateItems,
  prescription_templates: prescriptionTemplates,
  product_release_lines: productReleaseLines,
  product_releases: productReleases,
  purchase_order_lines: purchaseOrderLines,
  purchase_order_print_settings: purchaseOrderPrintSettings,
  purchase_orders: purchaseOrders,
  queue_entries: queueEntries,
  stock_movements: stockMovements,
  used_supplies: usedSupplies,
  user_patient_favorites: userPatientFavorites,
  user_provider_links: userProviderLinks,
  users: users,
  vital_definitions: vitalDefinitions,
};
